const MODES = { EMPTY: 'empty', NOT_FOUND: 'not-found' };

export default MODES;
